import React from 'react'
import PropTypes from 'prop-types'

import IconACGeneral from './IconGeneral'
import IconACSignals from './iconSignals'
import IconACDestinations from './IconDestinations'

import './styles.scss'

const icons = {
  general: <IconACGeneral />,
  signals: <IconACSignals />,
  destinations: <IconACDestinations />,
}

const Section = ({ icon, title, children }) => {
  return (
    <section className="ac-section">
      <header>
        {icons[icon]}
        <h1>{title}</h1>
      </header>
      <main>{children}</main>
    </section>
  )
}

Section.propTypes = {
  icon: PropTypes.oneOf(Object.keys(icons)).isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Section
